import { FC, ReactNode } from 'react';
import { NSpinner } from '@barracuda/shared';
import { TreatmentResult, useIsRegulaLivenessEnabled } from '@/hooks/useIsRegulaLivenessEnabled';
import { PageNotFound } from '../PageNotFound/PageNotFound';

interface LivenessRouteGuardProps {
  children: ReactNode;
}

export const LivenessRouteGuard: FC<LivenessRouteGuardProps> = ({ children }) => {
  const treatment = useIsRegulaLivenessEnabled();

  if (treatment === TreatmentResult.LOADING) {
    return <NSpinner />;
  }

  if (treatment === TreatmentResult.DISABLED) {
    return <PageNotFound />;
  }

  return <>{children}</>;
};
